import React, { useEffect, useState } from "react";
import {
	Button,
	Form,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
} from "reactstrap";

export default function CompareFetchMethodsModal({
	isOpen,
	onClose,
	url,
	onUrlChange,
	onSubmit,
	submitting,
}) {
	const [touched, setTouched] = useState(false);

	useEffect(() => {
		if (isOpen) {
			setTouched(false);
		}
	}, [isOpen]);

	const handleClose = () => {
		if (submitting) return;
		onClose();
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setTouched(true);
		if (!url?.trim()) return;
		onSubmit();
	};

	return (
		<Modal
			isOpen={isOpen}
			toggle={handleClose}
			centered
			size="md"
			modalClassName="dual-lens__compare-modal-overlay"
			className="dual-lens__compare-modal"
			backdrop={submitting ? "static" : true}
		>
			<ModalHeader
				tag="div"
				toggle={handleClose}
				className="dual-lens__compare-modal-header"
			>
				<div className="dual-lens__compare-modal-head">
					<div className="dual-lens__compare-modal-title">
						<i className="fas fa-globe text-primary me-2" aria-hidden />
						Compare fetch methods
					</div>
					<p className="dual-lens__compare-modal-subtitle mb-0">
						Enter a page URL to compare three captures: AI View (browser, JS off),
						Human View (browser load), and Human (with scroll).
					</p>
				</div>
			</ModalHeader>
			<Form onSubmit={handleSubmit}>
				<ModalBody className="dual-lens__compare-modal-body">
					<FormGroup className="mb-0">
						<Label for="dual-lens-modal-url" className="dual-lens__label">
							Page URL
						</Label>
						<Input
							id="dual-lens-modal-url"
							type="url"
							placeholder="https://example.com"
							value={url}
							onChange={(e) => onUrlChange(e.target.value)}
							disabled={submitting}
							className="dual-lens__url-input"
							autoFocus
						/>
						<div className="dual-lens__compare-modal-error">
							{touched && !url?.trim() && (
								<div className="text-danger small mt-1">Page URL is required.</div>
							)}
						</div>
					</FormGroup>
				</ModalBody>
				<ModalFooter className="dual-lens__compare-modal-footer">
					<Button
						color="secondary"
						outline
						type="button"
						onClick={handleClose}
						disabled={submitting}
					>
						Cancel
					</Button>
					<Button
						color="primary"
						type="submit"
						disabled={submitting}
					>
						{submitting ? "Submitting…" : "Fetch By URL & Compare"}
					</Button>
				</ModalFooter>
			</Form>
		</Modal>
	);
}
